import type {ListingStatuses} from "@hosttools/core/constant";
import {useMemo} from "react";

export function useStatusLabel(status?: ListingStatuses) {
    return useMemo(() => {
        const labelsMapping = {
            listed: "Listed",
            pending: "Pending",
            unlisted: "Unlisted",
            "not found": "Not Found"
        } satisfies Record<ListingStatuses, string>;

        return status ? labelsMapping[status] : "";
    }, [status]);
}
